import { render, staticRenderFns } from "./DryMillingPopup.vue?vue&type=template&id=10dd3366&scoped=true"
import script from "./DryMillingPopup.vue?vue&type=script&lang=js"
export * from "./DryMillingPopup.vue?vue&type=script&lang=js"
import style0 from "./DryMillingPopup.vue?vue&type=style&index=0&id=10dd3366&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dd3366",
  null
  
)

export default component.exports